import { render } from "./inputTag.vue?vue&type=template&id=7a8c7d3e"
import script from "./inputTag.vue?vue&type=script&lang=js"
export * from "./inputTag.vue?vue&type=script&lang=js"

import "./inputTag.vue?vue&type=style&index=0&id=7a8c7d3e&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__